<div class="mobile-support">
  <div class="images">
    <img src="/assets/images/macbook.svg" />
    <img src="/assets/images/imac.svg" />
  </div>
  <p class="subtitle2">We don’t support this page on mobile</p>
  <p class="body2">Unfortunately, this page is not supported on small devices just yet.</p>
</div>

